import { useMemo } from "react";

import extendedFieldHooks from "ExtendedFields/selectorHooks";

import FnrCard from "UI/FnrCard/FnrCard";
import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrSelectList2 from "UI/FnrSelectList2/FnrSelectList2";

import extendedFieldInputContainers from "../containers";

import extendedFieldDefaultCountries from "./countries";

const { VerticalGap, IconContainer, VerticallyCentered } =
  extendedFieldInputContainers;

const ChangeCountry = () => {
  const [changeCountry, setChangeCountry] =
    extendedFieldHooks.useChangeCountry();
  const [defaultCountry, setDefaultCountry] =
    extendedFieldHooks.useDefaultCountry();
  const isReadOnly = extendedFieldHooks.useIsReadOnly();
  const selectedCountry = useMemo(() => {
    return extendedFieldDefaultCountries.find(
      ({ id }) => id === defaultCountry
    );
  }, [defaultCountry]);

  const handleSetChangeCountry = () => setChangeCountry(!changeCountry);
  const handleSetDefaultCountry = ({ id }) => setDefaultCountry(id);

  return (
    <FnrCard data-cy="ExtendedFields_ChangeCountry">
      <VerticallyCentered>
        <IconContainer $color="textSecondary">
          <FnrIcon icon="fa-flag fas" />
        </IconContainer>
        <VerticalGap>
          <FnrCheckbox
            on={changeCountry}
            toggleOn={handleSetChangeCountry}
            disabled={isReadOnly}
            data-cy="ChangeCountry_Checkbox"
          >
            Allow members to change their country.
          </FnrCheckbox>
          <FnrSelectList2
            options={extendedFieldDefaultCountries}
            selected={selectedCountry}
            name="defaultCountry"
            onSelect={handleSetDefaultCountry}
            data-cy="ExtendedFields_ChangeDefaultCountry"
            disabled={isReadOnly}
          />
        </VerticalGap>
      </VerticallyCentered>
    </FnrCard>
  );
};

export default ChangeCountry;
